import { ToggleButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { FormFieldset } from 'src/shared/components/form/formFieldset';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { StyledToggleButtonGroup } from 'src/shared/components/organisms/styledToggleButtonGroup';
import { MemberStatusTabKeysEnum } from 'src/shared/models/enums/memberStatusTabKeys.enum';
import { useState } from 'react';
import { MemberTabItem, memberTabs } from '../models/memberTabs';

const limitedMemberTabs = memberTabs.filter((x) => x.key !== 'active');

type MemberOverviewStatusesProps = {
  otherContactMode: boolean;
  initialValue: MemberTabItem[];
  callback: (statuses: MemberTabItem[]) => void;
};

export const MemberOverviewStatuses = (props: MemberOverviewStatusesProps) => {
  const { otherContactMode, initialValue, callback } = props;
  const { setValue } = useFormContext();
  const { t } = useTranslation(['member']);

  const [selectedKeys, setSelectedKeys] = useState<string[]>(
    initialValue && initialValue.length ? initialValue.map((x) => x.key) : [MemberStatusTabKeysEnum.Paid, MemberStatusTabKeysEnum.NotPaid],
  );

  const handleKeys = (event: React.MouseEvent<HTMLElement>, newKeys: string[]) => {
    const selected = limitedMemberTabs.filter((item) => newKeys.includes(item.key));
    ConsoleHelper.log('handleKeys', selected);
    setSelectedKeys(newKeys);
    setValue('status', selected || []);
    callback(selected || []);
  };

  return (
    <FormFieldset legend={t('member:memberAdvancedSearch.status')} noPadding>
      <StyledToggleButtonGroup value={selectedKeys} onChange={handleKeys} color='primary' size='small'>
        {limitedMemberTabs
          .filter((x) => !(x.hiddenForOtherContactMode && otherContactMode))
          .map((x) => (
            <ToggleButton value={x.key} key={x.key}>
              {t(x.label)}
            </ToggleButton>
          ))}
      </StyledToggleButtonGroup>
    </FormFieldset>
  );
};
